import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components';
import { Link } from '@base/components/ui';
import { getConfig } from '@base/constants';

import { ITopMenuIconLinkProps } from './types';

import * as s from './TopMenuIconLink.scss';

export const TopMenuIconLink: React.FC<ITopMenuIconLinkProps> = (props: ITopMenuIconLinkProps ) => {
	const {
		className,
		classNameIcon,
		url,
		icon,
		title,
		notify,
	} = props;
	const {
		hosts: { baseUrl = '/' },
		isTestServer,
	} = getConfig();
	const baseLocation = isTestServer ? baseUrl : '';

	return (
		<Link
			title={title}
			className={classNames(s.block, className)}
			to={baseLocation + url}
			isSimpleLink
		>
			<Icon
				className={classNames(s.icon, classNameIcon)}
				glyph={icon}
			/>
			{ !!notify && <i className={s.mark}>{notify}</i> }
		</Link>
	);
};

